import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class LeaderboardScoreLabel extends Component {
  static propTypes = {
    children: PropTypes.oneOfType([(item) => !item, PropTypes.string.isRequired]),
    hide: PropTypes.bool,
  };

  static defaultProps = {
    hide: false,
    className: '',
  };

  render() {
    const { children, className, hide } = this.props;

    if (children === undefined) {
      return null;
    }

    return (
      <span className={`score-label ${className}`} style={hide ? { opacity: 0 } : {}}>
        <span className="rotated">{children}</span>
      </span>
    );
  }
}
